// extracted by mini-css-extract-plugin
module.exports = {"brickLoaderContainer":"brick-loader_brickLoaderContainer__3eGYa","loaderVisible":"brick-loader_loaderVisible__2rURR"};